export default __webpack_public_path__ + "static/media/texture1.b8252e8d.jpeg";